//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { filter, commonApi } from "@/common/index";
import { mapState } from "vuex";
import { parseTime } from "@/common/utils/Date.js";
export default {
  name: "merchDetail",
  data() {
    return {
      balanceDetail: {},
    };
  },
  computed: {
    ...mapState({
      UUID: (state) => state.UUID,
    }),
  },
  filters: {
    moneyFilter(money) {
      return filter.toMoney(money);
    },
    timeFilter(time) {
      return parseTime(time);
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      let params = {
        UUID: this.UUID,
        assetsBalanceLogId: this.$route.query.id,
        payType: this.$route.query.payType,
      };
      commonApi.VIP.getBalanceDetail(params).then((data) => {
        this.balanceDetail = data;
      });
    },

    filterTradingType(val) {
      if (val === "0") val = "100";
      return this.$t("mine").tradingRecord.tradingTypeOptions[val];
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/MerchRecord/merchDetail.vue